import { Box, Typography, Grid } from "@mui/material";

interface CategoryBoxProps {
  titlePrincipal: string;
  titleItem1: string;
  captionitem1: string;
  titleItem2: string;
  captionitem2: string;
  titleItem3: string;
  captionitem3?: string;
}

export const CategoryBox = (props: CategoryBoxProps) => {
  return (
    <Box sx={{ backgroundColor: "#fafafa", p: 2 }}>
      <Typography variant="h6">{props.titlePrincipal}</Typography>
      <Grid container spacing={1}>
        <Grid item xs={8} sm={3}>
          <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "bold" }}>
            {props.titleItem1}
          </Typography>
          <Typography variant="footer">{props.captionitem1}</Typography>
        </Grid>
        <Grid item xs={8} sm={3}>
          <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "bold" }}>
            {props.titleItem2}
          </Typography>
          <Typography variant="footer">{props.captionitem2}</Typography>
        </Grid>
        {props.captionitem3 != "" ? (
          <Grid item xs={8} sm={3}>
            <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "bold" }}>
              {props.titleItem3}
            </Typography>
            <Typography variant="footer">{props.captionitem3}</Typography>
          </Grid>
        ) : <></>}

      </Grid>
    </Box>
  );
};